import { render } from "./TimelineComponent.vue?vue&type=template&id=065eb055&scoped=true&ts=true"
import script from "./TimelineComponent.vue?vue&type=script&lang=ts"
export * from "./TimelineComponent.vue?vue&type=script&lang=ts"

import "./TimelineComponent.vue?vue&type=style&index=0&id=065eb055&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065eb055"]])

export default __exports__